<template>
    <div class="ut-container-lg ut-text-center">
        <h2 class="ut-pt-7 ut-text-lg ut-font-bold">404: Page not found</h2>
            <br />
        {{ msg }}
    </div>
</template>

<script>
export default {
  name: 'NotFound',
  props: [
    'msg',
  ],
  computed: {

    message() {
      return this.msg;
    },
  },
};
</script>

<style scoped>

</style>
